// extracted by mini-css-extract-plugin
export default {"outerContainer":"wordList_outerContainer__CRqqF","checkBoxContainer":"wordList_checkBoxContainer__T0DwH"};